import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const HelpContact = () => (
  <Row>
    <Col className="text-center text-dark-emphasis">
      <p>
        Having Trouble? Please call CIU Directly at
        562-795-1700.
      </p>
    </Col>
  </Row>
);
